// getLivestreamChatPrice.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getLiveStreamData from '../selector/getLiveStreamData.js';

/**
 * Select livestream chat price by stream id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - stream id.
 * @return {number} The selected livestream chat price.
 */
const getLivestreamChatPrice = createCachedSelector(
  (state, streamId) => getLiveStreamData(state, [streamId], 'chatPrice'),
  (price = 0) => +price
)((state, streamId) => `${streamId}`);

export default getLivestreamChatPrice;
